var styles = {"box":"Item_box_t56nf_1","vertical":"Item_vertical_t56nf_10","active":"Item_active_t56nf_16","horizontal":"Item_horizontal_t56nf_20"};

export { styles as default };
//# sourceMappingURL=index.module.scss.js.map
